/* Loads Google reCAPTCHA only when a captcha widget is about to be used.
 *
 * The newsletter form in the footer carries a captcha on every page, and the
 * reCAPTCHA script plus its iframe cost roughly 700 KB of JavaScript. Nobody
 * needs that until they reach the form, so api.js is injected the first time
 * a form containing a widget scrolls near the viewport or receives focus.
 * api.js renders every .g-recaptcha element itself once it has loaded, so no
 * further wiring is needed.
 */
(function() {
  var widgets = document.querySelectorAll('.g-recaptcha');
  if (!widgets.length) {
    return;
  }

  var loaded = false;
  function load() {
    if (loaded) {
      return;
    }
    loaded = true;
    var script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  [].forEach.call(widgets, function(widget) {
    var form = widget.closest ? widget.closest('form') : null;
    if (form) {
      form.addEventListener('focusin', load, { once: true });
      form.addEventListener('touchstart', load, { once: true, passive: true });
    }
  });

  if (!('IntersectionObserver' in window)) {
    load();
    return;
  }
  var observer = new IntersectionObserver(function(entries) {
    var near = entries.some(function(entry) {
      return entry.isIntersecting;
    });
    if (near) {
      observer.disconnect();
      load();
    }
  }, { rootMargin: '400px 0px' });
  [].forEach.call(widgets, function(widget) {
    observer.observe(widget);
  });
})();
